export default __webpack_public_path__ + "static/media/qt-icon.c4907f0f.svg";